<template>
  <div class="th-popover">
    <el-popover
      trigger="click"
      :title="title"
      :placement="placement"
      width="auto"
    >
      <template #reference>
        <button
          type="button"
          class="rounded-full outline-none focus:ring"
          :aria-label="buttonLabel || undefined"
          :data-testid="buttonTestId || undefined"
        >
          <slot name="icon" />
          <info-icon v-if="!$slots.icon" class="block text-th-text-regular" />
        </button>
      </template>
      <div
        v-if="text"
        class="text-left max-w-sm break-normal bg-white"
        :class="{ italic: !isWhiteLabel }"
      >
        <!-- Supporting new line -->
        <span v-for="(line, lineNumber) of text.split('\n')" :key="lineNumber">
          {{ line }}<br />
        </span>
      </div>
      <template v-if="$slots.default">
        <slot />
      </template>
      <template v-if="content.src">
        <iframe
          :width="content.width || '500'"
          :height="content.height || '311'"
          v-bind="content"
        />
      </template>
    </el-popover>
  </div>
</template>

<script>
import { isUnifiedCommerce } from '@shared/constants'
import { InfoIcon } from '@shared/assets/icons'

export default {
  components: {
    InfoIcon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    content: {
      type: Object,
      default: () => ({})
    },
    /* the accessible name of the icon-only trigger button */
    buttonLabel: {
      type: String,
      default: ''
    },
    buttonTestId: {
      type: String,
      default: ''
    }
  },
  computed: {
    isWhiteLabel() {
      return isUnifiedCommerce()
    }
  }
}
</script>

<style scoped>
.th-popover {
  line-height: 0;
}
</style>
